import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../utils/seo";

const setMetaTag = (name, content) => {
  if (!name) return;
  const selector = `meta[name="${name}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.name = name;
    document.head.appendChild(element);
  }

  if (content == null || content === "") {
    element.remove();
    return;
  }

  element.content = content;
};

const setTitle = (title) => {
  if (title) {
    document.title = title;
  }
};

const scrollToTop = () => {
  if (typeof window !== "undefined" && window?.scrollTo) {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
};

const SeoRouteHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(location.pathname);
    if (seo) {
      setTitle(seo.meta_title || seo.page_title || document.title);
      setMetaTag("description", seo.meta_description || null);
      setMetaTag("keywords", seo.meta_keywords || null);
    } else {
      setMetaTag("description", null);
      setMetaTag("keywords", null);
    }

    scrollToTop();
  }, [location.pathname]);

  return null;
};

export default SeoRouteHandler;
